import { SCR_V2_SUMMARY_PRINT_STYLES } from "./SCRV2SummaryReportPrintStyles";

export const SCR_V2_COMPLETE_DETAIL_PRINT_STYLES = `${SCR_V2_SUMMARY_PRINT_STYLES}

.scr-v2-complete-detail-print-view {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #0f172a;
  line-height: 1.45;
  padding: 0;
  margin: 0;
  width: 100% !important;
  max-width: 100% !important;
}

.scr-v2-complete-detail-print-view .scr-v2-print-header {
  align-items: baseline;
  margin-bottom: 0.75rem;
  gap: 0.75rem;
}

.scr-v2-complete-detail-print-view .scr-v2-print-header__title {
  font-size: 18px;
}

.scr-v2-complete-detail-print-view .scr-v2-print-header__meta {
  font-size: 12px;
  color: #475569;
}

.scr-v2-complete-detail-print-view .scr-v2-print-info-strip {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.65rem 1rem;
  padding: 0.65rem 0.85rem;
  margin-bottom: 0.85rem;
  border-radius: 0.25rem;
}

.scr-v2-complete-detail-print-view .scr-v2-print-info-item__label {
  font-size: 10px;
  margin-bottom: 0.15rem;
}

.scr-v2-complete-detail-print-view .scr-v2-print-info-item__value {
  font-size: 13px;
}

.scr-v2-complete-detail-print-view .scr-v2-print-info-item__sub {
  font-size: 11px;
  margin-top: 0.1rem;
}

.scr-v2-print-filter-note {
  margin: -0.35rem 0 0.75rem;
  font-size: 12px;
  color: #475569;
}

.scr-v2-print-invoice-section {
  border: 1px solid #e2e8f0;
  border-radius: 0.35rem;
  margin-bottom: 0.9rem;
  overflow: visible;
  page-break-inside: avoid;
  break-inside: avoid;
}

.scr-v2-print-invoice-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.55rem 0.75rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.scr-v2-print-invoice-section__title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem 0.65rem;
  min-width: 0;
}

.scr-v2-print-invoice-section__label {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.scr-v2-print-invoice-section__count {
  display: inline-block;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #fff;
  font-size: 11px;
  font-weight: 700;
  color: #334155;
}

.scr-v2-print-invoice-section__amount {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.scr-v2-print-invoice-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 14.5px;
}

.scr-v2-print-invoice-table thead {
  display: table-header-group;
}

.scr-v2-print-invoice-table th,
.scr-v2-print-invoice-table td {
  border-bottom: 1px solid #e2e8f0;
  padding: 0.5rem 0.55rem;
  vertical-align: top;
  word-break: break-word;
}

.scr-v2-print-invoice-table th {
  background: #f1f5f9;
  font-size: 12.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #475569;
  text-align: left;
}

.scr-v2-print-invoice-table th.scr-v2-print-num,
.scr-v2-print-invoice-table td.scr-v2-print-num {
  text-align: right;
}

.scr-v2-print-invoice-table tbody tr {
  page-break-inside: avoid;
  break-inside: avoid;
}

.scr-v2-print-invoice-table__empty {
  text-align: center;
  color: #64748b;
  padding: 0.85rem 0.5rem !important;
}

.scr-v2-print-invoice-no {
  font-weight: 700;
}

.scr-v2-print-invoice-badges {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.2rem;
  margin-left: 0.25rem;
  vertical-align: middle;
}

.scr-v2-print-invoice-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 0;
  font-size: 9px;
  font-weight: 600;
  line-height: 1.2;
  padding: 1px 5px;
  border-radius: 3px;
  vertical-align: middle;
  white-space: nowrap;
  color: #1a1a1a;
  background: #fff;
  border: 1px solid #bdbdbd;
}

.scr-v2-print-invoice-badge--adjustments,
.scr-v2-print-invoice-badge--nonVizLink,
.scr-v2-print-invoice-badge--vizLink,
.scr-v2-print-invoice-badge--default {
  color: #1a1a1a;
  background: #fff;
  border-color: #bdbdbd;
}

.scr-v2-print-footer {
  margin-top: 0.75rem;
  font-size: 11px;
  color: #64748b;
  text-align: right;
}

@media print {
  .scr-v2-print-invoice-section {
    page-break-inside: auto;
    break-inside: auto;
  }

  .scr-v2-print-invoice-section__header {
    page-break-after: avoid;
    break-after: avoid;
  }
}
`;
